import { Button, Grid, TextField, Typography } from "@mui/material";
import Indexdasbord from "../../../composant/navbar/indexDashbord";
import { useEffect, useState } from "react";
import { Api_Token } from "../../../env";

export default function PageParametre() {
  return <Indexdasbord Children={<Parametre />} />;
}

function Parametre() {
  const [para, setPara] = useState([]);
  useEffect(() => {
    Api_Token.get("/parametre/getAll").then((res) => {
      setPara(res.data);
    });
  }, []);

  function Update(id, value) {
    Api_Token.put(`parametre/UpdateOneById/${id}`, {
      NewValue: value,
    });
  }
  return (
    <Grid container spacing={2} padding="2%">
      <Grid item xs={2}>
        <Typography variant="h4"> Parametre</Typography>
      </Grid>
      <Grid item xs={2}></Grid>
      {para.map((p) => (
        <Grid item xs={12}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              Update(p.id, e.target.value.value);
            }}
          >
            <Grid container spacing={2} sx={{ alignItems: "center" }}>
              <Grid item>
                <Typography variant="bold">{p.NameParametre} : </Typography>
              </Grid>
              <Grid item>
                <TextField
                  type={p.Type}
                  defaultValue={p.ValueParametre}
                  name="value"
                />
              </Grid>
              <Grid item>
                <Button type="submit" variant="contained">
                  Update
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      ))}
    </Grid>
  );
}
